import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_2 = { class: "flex align-items-center gap-2" }
const _hoisted_3 = {
  key: 1,
  class: "text-indigo-400"
}
const _hoisted_4 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPark = _resolveComponent("IconPark")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.referrer)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.referrer.endpoint_uid)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createTextVNode(_toDisplayString(_ctx.referrer.endpoint_uid), 1)
              ])), [
                [
                  _directive_tooltip,
                  'Zone UID',
                  void 0,
                  { left: true }
                ]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, _toDisplayString(_ctx.referrer.uuid), 1),
            _createVNode(_component_IconPark, {
              class: "cursor-pointer",
              type: "copy",
              theme: "outline",
              size: "10",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.referrer.uuid)))
            })
          ]),
          (_ctx.referrer.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.referrer.value), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('empty')), 1))
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('unknown')), 1))
  ]))
}